// @react
import React, { ReactElement } from 'react'
// @libraries
import { makeStyles } from '@material-ui/core/styles'
// @components
import ScrollToTop from 'modules/onBoarding/components/_common/ScrollToTop'
import Header from 'modules/onBoarding/components/_common/Header'
import CreateAccount from 'modules/onBoarding/pages/CreateAccount'
import { useParams } from 'react-router-dom'
import { ONBOARDING_STEPS } from '../../data/config'
import NavigationProvider from 'modules/common/context/navigation'

/**
 * OnBoarding - Form Wrapper (React Hook Form)
 * https://www.figma.com/file/qfo4N93iI12FDinKJQaXKH/ATD-MyATD-Desktop-2020?node-id=174%3A47986
 */

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    // height: '100vh',
    // maxWidth: '100vw',
    overflowX: 'hidden',
  },
  main: {
    background: '#fafafa',
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    '& > form': {
      flex: '1',
      display: 'flex',
      flexDirection: 'column',
      '& > div:last-child': {
        flex: '1',
      },
    },
    '& > div:last-child': {
      flex: '1',
      display: 'flex',
      flexDirection: 'column',
      '& > div:last-child': {
        flex: '1',
      },
    },
  },
}))

/**
 *
 * @constructor
 */
const OnBoarding = (): ReactElement => {
  const classes = useStyles()
  // @ts-ignore
  const { id } = useParams()

  const Component =
    ONBOARDING_STEPS.find((item, index) => {
      return index === parseInt(id)
    })?.component || CreateAccount

  return (
    <>
      <ScrollToTop />

      <div className={classes.container}>
        <Header id={id || 0} />
        <main className={classes.main}>
          <NavigationProvider>
            <Component />
          </NavigationProvider>
        </main>
      </div>
    </>
  )
}

export default OnBoarding
